import { CommonModule } from '@angular/common';
import { Component, computed, inject, input, OnDestroy, OnInit, signal, ChangeDetectionStrategy } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { SnackbarNotificationType, SnackbarToastItem } from '../../../classes/snackbar-notification.model';
import { IconSanitizerService } from '../../../services/icon-sanitizer.service';
import { SnackbarNotificationService } from '../../../services/snackbar-notification.service';

@Component({
    selector: 'lib-snackbar-notification',
    templateUrl: './snackbar-notification.component.html',
    styleUrls: ['./snackbar-notification.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CommonModule]
})
export class SnackbarNotificationComponent implements OnInit, OnDestroy {
    private readonly iconSanitizer = inject(IconSanitizerService);
    private readonly snackbar = inject(SnackbarNotificationService);

    readonly toast = input.required<SnackbarToastItem>();

    readonly snackbarNotificationType = SnackbarNotificationType;
    readonly showNotification = signal(false);
    readonly isVisible = computed(() => this.showNotification());
    readonly toastClasses = computed(() => {
        const classes = [this.toast().type];

        return classes.join(' ');
    });

    readonly closeIcon: SafeHtml = this.iconSanitizer.getIcon('close');
    readonly infoIcon: SafeHtml = this.iconSanitizer.getIcon('infoNotification');
    readonly warningIcon: SafeHtml = this.iconSanitizer.getIcon('warningNotification');
    readonly errorIcon: SafeHtml = this.iconSanitizer.getIcon('errorNotification');
    readonly successIcon: SafeHtml = this.iconSanitizer.getIcon('successNotification');
    private hideTimerId?: ReturnType<typeof setTimeout>;
    private closeTimerId?: ReturnType<typeof setTimeout>;

    ngOnInit(): void {
        this.clearTimers();
        this.showNotification.set(true);
        this.hideTimerId = setTimeout(() => {
            this.showNotification.set(false);
            this.closeTimerId = setTimeout(() => {
                this.snackbar.dismiss(this.toast().id);
            }, 600);
        }, this.toast().durationMs);
    }

    ngOnDestroy(): void {
        this.clearTimers();
    }

    closeWithAnimation(): void {
        this.clearTimers();
        this.hideTimerId = setTimeout(() => {
            this.showNotification.set(false);
            this.closeTimerId = setTimeout(() => {
                this.snackbar.dismiss(this.toast().id);
            }, 500);
        });
    }

    private clearTimers(): void {
        if (this.hideTimerId) {
            clearTimeout(this.hideTimerId);
            this.hideTimerId = undefined;
        }

        if (this.closeTimerId) {
            clearTimeout(this.closeTimerId);
            this.closeTimerId = undefined;
        }
    }
}
